<template>
  <section class="file-browser" :class="{'onprogress':progress, 'active': $parent.isFileBrowser}" tabindex="1">
    <!--
      Title Area
    -->
    <div class="title-area gutter">
      <div class="left">
        <div>
          <h2 class="title">{{ 'İmzalar'|trans }}</h2>
          <span class="description">{{ 'Dosya yöneticisi'|trans }}</span>
        </div>
      </div>
      <div class="right">
        <button
          type="button"
          onclick="document.getElementById('fileInput').click()"
          class="btn btn-upload btn-lg btn-success d-flex align-items-center"
        >
          <i class="fas fa-file-upload mr-2"></i>
          <span>{{ 'Dosya Ekle'|trans }}</span>
        </button>
        <input type="file" id="fileInput" multiple="true" @change="onUpload" style="display: none">
      </div>
    </div>

    <!--
      Action Area
    -->
    <div class="actions-area gutter">
      <div class="item">
        <label class="btn mb-0 pointer" for="selectAllBrowser">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="selectAllBrowser"
              :disabled="files.length < 1"
              :checked="isCheckAll()"
              @change="checkAll($event.target.checked)"
            >
            <label class="custom-control-label" for="selectAllBrowser">{{ 'Tümünü Seç'|trans }}</label>
          </div>
        </label>
      </div>
    </div>

    <!--
      Browser
    -->
    <div class="browser">
      <div class="wrap" v-if="files.length > 0">
        <div class="item" v-for="(file, index) in files">
          <!--Document-->
          <div class="main d-flex align-items-center">
            <div class="custom-control custom-checkbox mb-0">
              <input
                type="checkbox"
                class="custom-control-input"
                :id="'file' + index"
                :checked="isCheckAllDocument(file.signatures)"
                @change="checkAllDocument(file.signatures, $event.target.checked)"
              >
              <label class="custom-control-label" :for="'file' + index"></label>
            </div>
            <label :for="'file' + index" class="mb-0 d-flex align-items-center ml-1 pointer file-title">
              <i class="fas fa-file-pdf mr-3 fa-2x"></i><span>{{ file.name }}</span>
            </label>
            <a class="ml-auto dropfile text-info pointer" @click="$refs['document-details'].show(file)"><i class="fas fa-info-circle"></i></a>
            <a class="ml-2 text-danger dropfile pointer" @click="dropFile(index)"><i class="fas fa-trash"></i></a>
          </div>

          <!--Signatures-->
          <div class="signatures">
            <div class="ml-1 mt-2 d-flex align-items-center" v-for="(signature, sIndex) in file.signatures">
              <v-swatches
                v-model="signature.color"
                :swatches="$parent.colors"
                shapes="circles"
                row-length="4"
                popover-x="right"
              >
                <span slot="trigger"><i :style="{'color': signature.color}" class="fas fa-signature mr-3"></i></span>
              </v-swatches>

              <div class="custom-control custom-checkbox mt-1 mb-0">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="'signature' + index + sIndex"
                  v-model="signature['selected']"
                  :disabled="!isValidSignature(signature)"
                >
                <label
                  class="custom-control-label"
                  :class="{'text-danger': !isValidSignature(signature)}"
                  :for="'signature' + index + sIndex"
                >
                  {{ 'İmza'|trans }} {{ sIndex + 1 }}
                  <span v-if="!isValidSignature(signature)"> - {{ 'Yanlış Key'|trans }}</span>
                </label>
              </div>
              <div class="ml-auto">
                <a class="dropfile text-info pointer mr-1" v-tooltip :title="trans('İmza Doğrulama')" @click="$refs['signature-verify'].show(signature)"
                  v-if="isValidSignature(signature) & $parent.signatureVerify.enable">
                  <i class="fad fa-file-contract"></i>
                </a>
                <a class="dropfile text-info pointer" v-tooltip :title="trans('İmza Detayları')" @click="$refs['signature-details'].show(signature)" v-if="isValidSignature(signature)">
                  <i class="fas fa-info-circle"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Empty Data-->
      <div class="gutter empty-content" v-else>
        <p>{{ 'Analiz için dosya yükleyin.'|trans }}</p>
        <p>{{ 'Public anahtarınızı yüklediğinizden emin olun.'|trans }}</p>
      </div>
    </div>

    <!--
      RUN Button
    -->
    <div class="run gutter">
      <button
        class="btn btn-success d-flex align-items-center btn-block"
        @click="setSelectedSignature"
        :class="{'disabled': files.length < 1}"
      >
        <i class="fas fa-play-circle mr-3 fa-2x"></i>
        <span>{{ 'KARŞILAŞTIR'|trans }}</span>
      </button>
    </div>

    <!--
      Spinner
    -->
    <div class="spinner-border"><span class="sr-only">{{ 'Yükleniyor...'|trans }}</span></div>

    <!--
      Signature|Document Information
    -->
    <document-details ref="document-details"></document-details>
    <signature-details ref="signature-details"></signature-details>
    <signature-verify-check ref="signature-verify" v-if="$parent.signatureVerify.enable"></signature-verify-check>
  </section>
</template>

<script>
import Vue from 'vue';
import SignatureDetails from './Details/SignatureDetails';
import DocumentDetails from './Details/DocumentDetails';
import SignatureVerifyCheck from './Details/SignatureVerifyCheck';
import UUID from 'vue-uuid';
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'

Vue.use(UUID);

export default {
  components: {VSwatches, SignatureDetails, DocumentDetails, SignatureVerifyCheck},
  props: ['files', 'api', 'selected', 'svgAutoSize'],

  data() {
    return {
      uuid: this.$uuid.v4(),
      progress: false,

      prompts: 0,
      formData: null,
      uplodedFiles: {},
    }
  },

  methods: {
    /**
     * Has All Signatures Selected
     */
    isCheckAllDocument(signatures) {
      return signatures.filter((signature) => {
        if (signature instanceof Object) {
          return signature.selected;
        }
      }).length === signatures.length;
    },

    /**
     * Select All Signature
     */
    checkAllDocument(signatures, status) {
      signatures.map((signature) => {
        if (signature instanceof Object) {
          signature.selected = status;
        }
      });
    },

    /**
     * Has All Document Selected
     */
    isCheckAll() {
      return this.files.filter((document) => {
        return this.isCheckAllDocument(document.signatures)
      }).length === this.files.length
    },

    /**
     * Select All Document
     */
    checkAll(status) {
      this.files.forEach((document) => {
        this.checkAllDocument(document.signatures, status)
      })
    },

    /**
     * Valid Signaure
     */
    isValidSignature(signature) {
      return signature instanceof Object
    },

    /**
     * Remove file to File Browser
     */
    dropFile(index) {
      this.files.splice(index, 1);
    },

    /**
     * Process Biometric Data
     */
    processData(data) {
      let validData = [];

      // Add Selected Property
      data.forEach((document, docIndex) => {
        // Signature Not Found
        if (!document.hasOwnProperty('signatures')) {
          return new Noty({
            text: this.trans(`:document belgesinde imza bilgisi bulunamadı.`).replace(':document', document.name),
            type: 'error'
          }).show();
        }

        document.signatures.forEach((signature, index) => {
          if (signature instanceof Object) {
            let colorIndex = this.modCalc(index, this.$parent.colors.length);
            signature.selected = false;
            signature.id = this.trans('imza') + index.toString() + (Math.floor(Math.random() * 10000) + 1);
            signature.color = this.$parent.colors[colorIndex][this.modCalc(docIndex, this.$parent.colors[colorIndex].length)].color;
            signature.deviceInfo = JSON.parse(signature.deviceInfo);
          }
        })

        validData.push(document);
      })

      if (this.files.length < 1) {
        this.$emit('input', validData)
        return;
      }

      validData.forEach((file) => {
        this.files.push(file);
      })
    },

    /**
     * Modules Calculator
     */
    modCalc(n, m) {
      return ((n % m) + m) % m;
    },

    /**
     * Prepare FormData using Ajax File Upload
     */
    prepareFile(event) {
      this.formData = new FormData();
      let files = event.target.files;
      let v = this;

      // Reset Noty Prompt
      Noty.closeAll();

      for (const [id, file] of Object.entries(files)) {
        // Append File List to Vue Instance
        this.uplodedFiles[file.name] = file;

        // Private Key Prompt
        if (!file.type) {
          let question = this.trans(':filename için varsa şifre girin.').replace(':filename', file.name);
          let placeholder = this.trans('Şifre yoksa boş bırakın.');

          this.prompts += 1;
          let prompt = new Noty({
            theme: 'file-upload',
            text: `${question} <input type="text" class="form-control" placeholder="${placeholder}">`,
            closeWith: 'button',
            timeout: false,
            buttons: [Noty.button('<i class="fas fa-paper-plane mr-2"></i>' + this.trans('Gönder'), 'btn btn-success', () => prompt.close())],
            callbacks: {
              onClose: function () {
                // Find Password
                let password = this.barDom.querySelector('input').value;
                if (password) {
                  v.formData.append(file.name + '_password', password);
                }

                // Decrement Prompt and Re Upload
                v.prompts -= 1;
                v.onUpload(false);
              },
            }
          }).show();
        }

        // Add FormData to File
        this.formData.append(file.name, file);
      }
    },

    /**
     * File Upload Event
     *
     * @param event
     */
    onUpload(event) {
      if (event) {
        this.prepareFile(event);
      }

      if (this.prompts === 0) {
        $.ajax({
          url: this.api + '/' + this.uuid,
          data: this.formData,
          contentType: false,
          processData: false,
          cache: false,
          type: 'POST',
          dataType: 'json',
          mimeType: 'multipart/form-data',
          beforeSend: () => {
            this.progress = true;
          },
          success: (event) => {
            this.processData(event);
          },
          error: (event) => {
            if (event.responseJSON.message) {
              new Noty({
                text: event.responseJSON.message,
                type: 'error',
                timeout: 5000,
                layout: 'topRight',
              }).show();
            }
          },
          complete: (event) => {
            this.progress = false;
          }
        });
      }
    },

    /**
     * Set Selected Signature
     */
    setSelectedSignature() {
      // Enable SVG Auto Size
      this.$parent.svgAutoSize = true;

      // Clear
      this.selected.splice(0, this.selected.length);

      this.files
        .map((document) => {
          return {
            ...document,
            signatures: document.signatures.filter((signature) => {
              return signature.selected;
            })
          }
        })
        .forEach((document) => {
          if (document.signatures.length > 0) {
            this.selected.push(Object.freeze(document));
          }
        })
    },
  }
}
</script>

<style lang="scss">
$color-border: rgb(233, 233, 233);

.file-browser {
  flex: 1.25;
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 400px;
  outline: none;
  margin-left: -25px;

  .browser {
    overflow-y: scroll;
    height: 100%;
    max-height: 100%;

    .item {
      border-bottom: 1px solid $color-border;
      padding: 15px 15px;
      transition: .15s all;

      .main {
        font-size: 15px;
        font-weight: 500;

        label span {
          color: rgb(46, 144, 223);
        }
      }

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .text-info {
    color: rgb(46, 144, 223) !important;
  }

  .spinner-border {
    display: none;
  }

  &.onprogress {
    .spinner-border {
      display: flex;
      position: absolute;
      top: calc(50% - 20px);
      left: calc(50% - 20px);
    }

    &:after {
      background: rgba(0, 0, 0, 0.15);
      content: " ";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      transition: .2s all;
    }
  }

  .btn-upload {
    border-radius: 8px;
  }

  .dropfile {
    opacity: .6;
    transition: .15s all;

    &:hover {
      opacity: 1;
    }
  }

  .file-title{
    max-width: 78%;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.file-browser:not(.active) {
  position: absolute;
  width: 25px;
  flex: 0;
  bottom: 0;
  top: 0;
  right: 0;
  background: #FFF;
  transition: .3s all;

  &:after {
    content: " ";
    background: #d5d8e4;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: -2px;
    transition: .3s all;
    &:hover {
      cursor: pointer;
    }
  }

  &:focus, &:hover {
    width: 400px;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, .2);
    outline: none;

    &:after {
      content: none;
    }
  }
}

.run {
  border-top: 1px solid $color-border;

  .btn {
    font-size: 16px;
    font-weight: 500;
    border-radius: 8px;
    letter-spacing: .7px;
  }
}

.noty_theme__file-upload {
  border: 2px solid rgb(76 175 80);
  box-shadow: 0 0 1rem rgb(226 234 227);
  background: #FFF;
  margin-bottom: 10px;
  border-radius: 10px;

  .noty_body {
    input {
      margin-top: 10px;
    }
  }

  .btn {
    border-radius: 8px;
  }
}

.information {
  background: rgb(88 97 103 / 94%);
  color: #FFF;
  position: absolute;
  left: -2px;
  right: 0;
  top: 0;
  bottom: 0;
  font-size: 14px;

  .details {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: calc(100% - 70px);
    padding: 0 15px;

    .item {
      display: flex;
      align-items: center;
      margin-top: 20px;

      .type {
        flex: 1.5;
        user-select: none;
        font-weight: bold;
      }

      .value {
        flex: 2;
        word-break: break-all;
        padding-left: 10px;
      }
    }
  }

  .title {
    border-bottom: 2px solid rgba(255, 255, 255, .25);
    display: flex;
    align-items: center;
    padding: 15px 15px;

    h4 {
      margin-bottom: 0;
    }

    .close {
      margin-left: auto;
      background: #FFF;
      text-align: center;
      border-radius: 50%;
      width: 30px;
      height: 30px;

      i {
        font-weight: 300;
      }
    }
  }
}

.vue-swatches__container {
  border-radius: 2px !important;
  box-shadow: 0 0 10px #d9d9d9, 0 0 0 2px rgb(233, 233, 233) !important;
  padding: 10px !important;
  width: 150px;

  .vue-swatches__swatch {
    width: 32px !important;
    height: 32px !important;
    margin-right: 7px !important;
    margin-bottom: 7px !important;
    border-radius: 2px !important;
  }

  .vue-swatches__wrapper {
    padding: 0 !important;
    width: auto !important;
  }

  .vue-swatches__row {
    &:last-child{
      .vue-swatches__swatch{
        margin-bottom: 0 !important;
      }
    }
    .vue-swatches__swatch:last-child {
      margin-right: 0 !important;
    }
  }

  .vue-swatches__fallback__wrapper {
    display: flex;
    align-items: center;
    margin: 0 !important;
    padding: 0 !important;
    width: 150px !important;

    .vue-swatches__fallback__input--wrapper {
      padding-right: 0 !important;
      line-height: 0;

      .vue-swatches__fallback__input {
        height: 32px !important;
        padding: 0 2px !important;
        border-radius: 2px !important;
      }
    }

    .vue-swatches__fallback__button {
      padding: 4px 6px;
      margin-left: 7px;
      border-radius: 2px;
      font-weight: 400;
      height: 32px;
      min-width: 33px;
      text-transform: uppercase;
      outline: none;
    }
  }
}
</style>
